import { apiFetch } from "@/lib/api-client";
import type { ShoppingListResponse } from "@shared/api";

/** Shared fetch for shopping list – used by the page and by nav badge so the cache has full data. */
export async function fetchShoppingList(): Promise<ShoppingListResponse> {
  const res = await apiFetch("/api/shopping-list", { credentials: "include" });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { message?: string }).message || `HTTP ${res.status}`);
  }
  return res.json();
}
